// extracted by mini-css-extract-plugin
export default {"twoFactorBox":"TwoFactor_twoFactorBox__F81JE"};